/* eslint-disable no-unused-vars */
export enum INTERACTION_PARAMS {
  sync_with_portfolios_app = 'sync_with_portfolios_app',
}

export type InteractionParams = {
  [INTERACTION_PARAMS.sync_with_portfolios_app]: boolean;
};

export type Params = InteractionParams & {
  app_portfolio_id?: number;
};
export type DraftParams = Partial<Params>;
